import type { ParsedCanvasFrontend, TCanvasFrontend } from '@/types/common.ts';

export const parseCanvas = (canvas: TCanvasFrontend): ParsedCanvasFrontend => {
	return canvas.types.reduce(
		(prev, { items, idn, color, title, description }) => ({
			...prev,
			configs: {
				...prev.configs,
				[idn]: { idn, color, title, description }
			},
			sections: {
				...prev.sections,
				[idn]: items
			}
		}),
		{
			sections: {},
			configs: {}
		} satisfies ParsedCanvasFrontend
	);
};
